
export class SectionNavigationModule{
    private nav: HTMLElement;

    constructor() {
    }

    init(){
        let scrollpos = window.scrollY
        this.nav = document.querySelector(".section--navigation") as HTMLElement
        if(!this.nav) return;
        const nav_height = this.nav.offsetHeight
        const add_class_on_scroll = () => this.nav.classList.add("bg-navyDark")
        const remove_class_on_scroll = () => this.nav.classList.remove("bg-navyDark")
        const scrollHandler = () => {
            scrollpos = window.scrollY;
            if (scrollpos >= nav_height) { add_class_on_scroll() }
            else { remove_class_on_scroll() }

        }

        setTimeout(() => scrollHandler(), 1);

        window.addEventListener('scroll', scrollHandler);
        this.toggleMenu();
        window.addEventListener('resize', () => {
            this.toggleMenu()
        })

        const menu = document.querySelector('.menu') as HTMLElement;
        menu.addEventListener("click", event => {
            this.nav.classList.toggle('navigation--open');
        })

    }
    toggleMenu() {
        if (window.innerWidth < 1290) {
        // if (window.innerWidth < 1280) {
            this.nav.classList.add('navigation--mobile');
            // const menu = document.querySelector('.menu') as HTMLElement;
            // menu.addEventListener("click", event => {
            //     if (this.nav.classList.contains('navigation--open')) {
            //         this.nav.classList.remove('navigation--open');
            //     } else {
            //         this.nav.classList.add('navigation--open');
            //     }
            // })
        } else {
            this.nav.classList.remove('navigation--mobile');
        }
    }


}
